import { render, staticRenderFns } from "./vocabularyTest2.vue?vue&type=template&id=1a74343c&scoped=true"
import script from "./vocabularyTest2.vue?vue&type=script&lang=js"
export * from "./vocabularyTest2.vue?vue&type=script&lang=js"
import style0 from "./vocabularyTest2.vue?vue&type=style&index=0&id=1a74343c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a74343c",
  null
  
)

export default component.exports